import React from 'react';
import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom";
import buildLink from "../funcs/buildlink";

export default class PostThumbnail extends React.Component{
  render(){
    var cs = ['post_thumbnail'];
    if(this.props.hidePosts){
      cs.push('post_only_video');
    }

    var v = this.props.video;
    if(!Array.isArray(v)){
      v = [this.props.video];
    }

    return(
      <div className={cs.join(' ')}>
        <Link to={buildLink('/' + this.props.slug)}>
        <div className="post_thumbnail_date">
          {this.props.date}
        </div>
        {
          !this.props.hidePosts ?
          <div className="post_thumbnail_img" style={{backgroundImage: 'url('+this.props.img+')'}}>
          </div>
          : null
        }

        <div className="post_thumbnail_info">
          <div className="post_thumbnail_info_title">
            {this.props.title}
          </div>
        </div>
        </Link>
        {
          !this.props.hideVideos ?
          <>
          {
            v.map(function(vurl){
              return (
                <div className="post_thumbnail_img" style={{marginTop: '1.25rem'}}>
                  <iframe width="560" height="315" src={vurl} frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
              )
            })
          }

          </>
          : null
        }

      </div>
    )
  }
}
